export default __webpack_public_path__ + "static/newsletterForm-c3cb88c4af1c3a6fe282201e9d61a639.png";